// extracted by mini-css-extract-plugin
export var content = "ProducerList-module--content--j+NJH";
export var grid = "ProducerList-module--grid--YcGiR";
export var imageSection = "ProducerList-module--imageSection--JGFHi";
export var item = "ProducerList-module--item--X8c5S";
export var label = "ProducerList-module--label---48G-";
export var link = "ProducerList-module--link--2hivj";
export var text = "ProducerList-module--text--+XSfX";
export var wrapper = "ProducerList-module--wrapper--i7ZLH";